import { Link } from "react-router-dom";
import "./AnnouncementBar.css";

function AnnouncementBar() {
  return (
    <div className="announcement-wrapper">
      <div className="announcement-track">

       <Link to="/contact" className="ann-link">📄 Apply For Admissions</Link>
<span>📢 Admissions Open</span>
<Link to="/apply" className="ann-link">📄 Apply For Admissions</Link>
<span>📢 Admissions Open</span>
<Link to="/apply" className="ann-link">📄 Apply For Admissions</Link>

      </div>
    </div>
  );
}

export default AnnouncementBar;

